import { Button, Stack, Typography } from '@mui/material'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { SimplePageWrapper } from '~/@ui/simple-page-wrapper/SimplePageWrapper'
import ArrowRightWhiteSvg from '~/@ui/_sharedSvgs/ui/ArrowRightWhite.svg?react'
import { useEffect, useState } from 'react'
import { getApi } from '~/@utils/api/getApi'
import { getErrorMessage } from '~/@utils/api/getErrorMessage'
import BonashipDocuments from './BonashipDocuments.webm'
import { useAlert } from '~/@ui/alert/useAlert'

export const DocumentsInfoPage = () => {
  const { orderId = '' } = useParams()
  const navigate = useNavigate()
  const { showAlert } = useAlert()

  const [estateId, setEstateId] = useState('')

  const getOrder = async () => {
    try {
      const { data: response } =
        await getApi().ownerPensionOrderAppApiControllerGetOwnerPensionOrder(
          orderId
        )

      if ('success' in response) {
        setEstateId(response.ownerPensionOrder.estateId || '')
        return
      }

      throw new Error('Nastala chyba pri načítavaní dát o objednávke.')
    } catch (err) {
      console.error(err)
      showAlert('error', getErrorMessage(err))
    }
  }

  useEffect(() => {
    if (!orderId) {
      navigate('/vlastnik/dotaznik/adresa-nehnutelnosti')
      return
    }

    getOrder()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <SimplePageWrapper
      onClickBack={() =>
        navigate(`/vlastnik/dotaznik/mesacny-dochodok/${estateId}`)
      }>
      <Stack className="h-full justify-center items-center gap-12 px-5 pb-28">
        <video
          className="w-[250px] h-[250px] rounded-4d object-cover"
          autoPlay
          muted
          loop
          playsInline>
          <source src={BonashipDocuments} type="video/webm" />
          Váš prehliadač nepodporuje video element.
        </video>

        <Stack className="items-center text-center gap-3">
          <Typography className="text-xl font-bold text-zBlack200">
            Potrebné dokumenty
          </Typography>
          <Typography className="text-3d font-medium text-zGrey400">
            Prosíme, pripravte si výpis z bankového účtu, kam vám za posledné
            tri mesiace prišiel dôchodok, a list vlastníctva.
          </Typography>
        </Stack>

        <Button
          component={Link}
          to={`/vlastnik/dotaznik/nahravanie-dokumentov/${orderId}`}
          variant="contained"
          className="w-16 h-11">
          <ArrowRightWhiteSvg />
        </Button>
      </Stack>
    </SimplePageWrapper>
  )
}
